import React from 'react';
import PropTypes from 'prop-types';
import { useTranslation } from 'react-i18next';
import useClassNames from '@medflex/hooks/useClassNames';

const SIZES = {
  small: 'w-3 h-3',
};

const OnlineStatus = ({ className, size }) => {
  const { t } = useTranslation('components', { keyPrefix: 'OnlineStatus' });
  const cn = useClassNames(
    () => [SIZES[size], 'rounded-full', 'bg-green-500', className],
    [className],
  );

  return <div title={t('online')} className={cn} />;
};

OnlineStatus.propTypes = {
  className: PropTypes.oneOfType([
    PropTypes.string,
    PropTypes.func,
    PropTypes.array,
    PropTypes.object,
  ]),
  size: PropTypes.oneOf(['small']),
};

OnlineStatus.defaultProps = {
  className: '',
  size: 'small',
};

export default OnlineStatus;
